import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  id: null,
  isEdit: false,
  isView: false,
  isDelete: false,
  isShare: false,
  table: false,
};

const templateSlice = createSlice({
  name: "template",
  initialState,
  reducers: {
    setTemplateForEdit: (state, action) => {
      state.id = action.payload.id;
      state.isEdit = action.payload.isEdit;
      state.table = action.payload.table;
    },
    setTemplateForView: (state, action) => {
      state.id = action.payload.id;
      state.isView = action.payload.isView;
      state.table = action.payload.table;
    },
    setTemplateForDelete: (state, action) => {
      state.id = action.payload.id;
      state.isDelete = action.payload.isDelete;
      state.table = action.payload.table;
    },
    setTemplateForShare: (state, action) => {
      state.id = action.payload.id;
      state.isShare = action.payload.isShare;
      state.table = action.payload.table;
    },
    resetTemplateState: (state) => {
      state.id = null;
      state.isEdit = false;
      state.isView = false;
      state.isDelete = false;
      state.isShare = false;
      state.table = false;
    },
  },
});

export const {
  setTemplateForEdit,
  setTemplateForDelete,
  setTemplateForView,
  setTemplateForShare,
  resetTemplateState,
} = templateSlice.actions;
export default templateSlice.reducer;
